module.exports = __webpack_public_path__ + "img/reddit.3119fbc0.svg";